import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BonusqrService, BonoPacienteEstaticoBody } from 'src/app/shared/servicio/bonusqr/bonusqr.service';

@Component({
  selector: 'app-bono-estatico',
  templateUrl: './bono-estatico.component.html',
  styleUrls: ['./bono-estatico.component.css'],
})
export class BonoEstaticoComponent implements OnInit {
  code: string;
  loading = true;
  submitting = false;

  medicDisplayName = '';
  specialties: { id: number; name: string }[] = [];
  isActive = false;
  notFound = false;
  errorMessage = '';

  redeemed = false;
  couponId = '';
  successMessage = '';
  formErrorMessage = '';

  constructor(private _route: ActivatedRoute, private _bonusqr: BonusqrService) {}

  ngOnInit(): void {
    this.code = this._route.snapshot.paramMap.get('code');
    this.verify();
  }

  verify(): void {
    this.loading = true;
    this.notFound = false;
    this.errorMessage = '';

    this._bonusqr.verifyStaticQr(this.code).subscribe(
      (data: any) => {
        this.medicDisplayName = data.medic_display_name;
        this.specialties = data.specialties || [];
        this.isActive = data.is_active;
        if (!this.isActive) {
          this.errorMessage = 'Este codigo ya no esta disponible. Por favor consulte en recepcion.';
        }
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        if (error.status === 410) {
          this.isActive = false;
          this.errorMessage = (error.error && error.error.message) || 'Este codigo ya no esta disponible.';
        } else {
          this.notFound = true;
          this.errorMessage = (error.error && error.error.message) || 'Codigo QR no valido';
        }
      }
    );
  }

  onFormSubmit(body: BonoPacienteEstaticoBody): void {
    this.submitting = true;
    this.formErrorMessage = '';

    this._bonusqr.redeemStaticQr(this.code, body).subscribe(
      (data: any) => {
        this.submitting = false;
        this.redeemed = true;
        this.couponId = data.coupon_id;
        this.successMessage = data.message;
      },
      (error) => {
        this.submitting = false;
        this.formErrorMessage = (error.error && error.error.message) || 'Datos no validos';
      }
    );
  }
}
